const Q8NoData = () => (
  <div className="nessun-dato">Nessun dato disponibile</div>
);

export default Q8NoData;
